import i18n from "i18next";

import { defaultLanguage, languages } from "./languages";

const SUPPORTED_LANGUAGE_CODES: readonly string[] = languages.map(
  (language) => language.code,
);

interface IResolveActiveLanguageProps {
  i18nLanguage?: string | null;
  storedLanguage?: string | null;
}

// NOTE: NSAI-4678 — the server localizes gateway and REST copy from the language
// the client reports (`client.handshake.auth.language`, `X-App-Language`), so a
// client that reports nothing silently gets English back. Mobile takes its
// language from the device locale and never persists it, which is exactly that
// case, so the live i18next language has to win over the stored one.
const resolveActiveLanguage = ({
  i18nLanguage,
  storedLanguage,
}: IResolveActiveLanguageProps): string => {
  const candidates = [i18nLanguage, storedLanguage];

  for (const candidate of candidates) {
    // NOTE: i18next may resolve a region-tagged locale ("ru-RU"); the server
    // keys its translations by the base code only.
    const baseCode = candidate?.split("-")[0]?.toLowerCase();

    if (baseCode && SUPPORTED_LANGUAGE_CODES.includes(baseCode)) {
      return baseCode;
    }
  }

  return defaultLanguage;
};

export const getActiveLanguage = (storedLanguage?: string | null): string =>
  resolveActiveLanguage({ i18nLanguage: i18n.language, storedLanguage });
